import { uuid } from "@xapp/chat-widget-core";
import { ChatState } from "../ChatState";
import { createDefaultState, DEFAULT_STATE } from "../DefaultState";

export function resetReducer(state: ChatState = DEFAULT_STATE): ChatState {
    // pass through some of the items to persis
    return {
        // These fields are the same ones we pass to this function when we create the initial state from WidgetEnv
        // in createChatStore()
        ...createDefaultState({
            accessToken: state.accessToken,
            userId: state.userId,
            attributes: state.attributes,
            sessionExpiration: state.sessionExpiration
        }),
        connection: {
            ...state.connection,
            greetingRequested: false,
            nonce: uuid()
        },
        visitor: state.visitor,
        visitorId: state.visitorId
    };
}
